import React, { useContext, useEffect, useState } from "react";
import { Snackbar, Stack, TextField } from "@mui/material";
import { Paper } from "@mui/material";
import { TableFooter, TablePagination } from "@mui/material";
import { TableBody, TableHead } from "@mui/material";
import { TableContainer, TableCell, TableRow } from "@mui/material";
import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import TablePaginationActions from "../../../Components/Pagination/pagination";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import { StyledTableHead } from "../../../Styles/tabelCellStyled/customTableCell";
import { StyledTableCell } from "../../../Styles/tabelCellStyled/customTableCell";
import { CustomThemeProvider } from "../../../Styles/theme/customThemeprovider";
import { CustomTextField } from "../../../Styles/theme/customThemeprovider";
import BasicPopover from "../../../Components/Popover";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import { del, get, post } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";
import LoadingVulpes from "../../../Styles/Loader/loading";
import { IAguaDeRega, ICabecalho5D } from "../../../Interfaces/cadernos/caderno5/interfaces5D";
import { Alert } from "../../../Components/Alert/Alert";
import { format_strings_to_numbers } from "../../../Componentes_modulo/formulas_genericas/formulas_genericas";
import { formatarNumero_recebido_com_casa_decimais } from "../../../Func_genericas/formatar_numero_formato_pt";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { mensagem_tem_a_certeza_de_apagar_alteracoes, message_apenas_numero } from "../../../Func_genericas/valores_estaticos";
import { useLocation } from "react-router-dom";

interface IAguaRegaProps {
  cabecalho: ICabecalho5D | undefined;
  rowsAgua: IAguaDeRega[];
  setRowsAgua: React.Dispatch<React.SetStateAction<IAguaDeRega[]>>;
  rowsAgua_filtrada: IAguaDeRega[];
  setRowsAgua_filtrada: React.Dispatch<React.SetStateAction<IAguaDeRega[]>>;
}

export const AguaRegaForm: React.FC<IAguaRegaProps> = ({
  cabecalho,
  rowsAgua,
  setRowsAgua,
  rowsAgua_filtrada,
  setRowsAgua_filtrada,
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const auth = useContext(AuthContext);
  const location = useLocation();
  const is_historico = location.state?.is_historico ?? false;

  const [obj_editar, set_obj_editar] = React.useState<IAguaDeRega | undefined>();

  const [openSnackSuccess, setOpenSnackSuccess] = React.useState<boolean>(false);
  const [openSnackError, setOpenSnackError] = React.useState<boolean>(false);
  const [message, setMessage] = React.useState<string>("");

  const [showNewRow, setShowNewRow] = useState<boolean>(false);
  const [openDeleteAgua, setOpenDeleteAgua] = React.useState(false);

  const [error_data, set_error_data] = useState<boolean>(false);
  const [error_eficiencia_rega, set_error_eficiencia_rega] = useState<boolean>(false);
  const [error_volume, set_error_volume] = useState<boolean>(false);
  const [error_dotacao, set_error_dotacao] = useState<boolean>(false);
  const [error_teor, set_error_teor] = useState<boolean>(false);
  const [error_kg_n, set_error_kg_n] = useState<boolean>(false);

  const [total_volume, set_total_volume] = useState<number>(0);
  const [total_dotacao, set_total_dotacao] = useState<number>(0);
  const [total_teor, set_total_teor] = useState<number>(0);
  const [total_kg_n, set_total_kg_n] = useState<number>(0);

  const [flag_editado, set_flag_editado] = React.useState(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);

  const handleCloseDialog = () => {
    handleCancel()


    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
  };
  const sumatorio_das_quantidades = (lista: IAguaDeRega[]) => {

    let total_volume_final = 0
    let total_dotacao_final = 0
    let total_teor_final = 0
    let total_kg_n_final = 0

    lista.forEach((el) => {
      total_volume_final += el.volume
      total_dotacao_final += el.dotacao
      total_teor_final += el.teor
      total_kg_n_final += el.kg_n
    })

    set_total_volume(total_volume_final)
    set_total_dotacao(total_dotacao_final)
    set_total_teor(total_teor_final)
    set_total_kg_n(total_kg_n_final)
  }

  async function getAgua() {
    setIsLoading(true);
    try {
      let res = await get(auth.token.cookie_token, `/get_reg_act_fertil_azotada_dois_5d_cabecalho/${cabecalho?.id_act_feertil_azotada}`);

      if (res.status === 200) {
        setRowsAgua(res.data.result);
        setRowsAgua_filtrada(res.data.result);
        sumatorio_das_quantidades(res.data.result)

      }
      setIsLoading(false);
    } catch (error) {
      func_print("getAgua", error, true);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    (async () => {
      await getAgua();
    })();
  }, [cabecalho?.id_act_feertil_azotada]);

  //Criar
  const handleCancel = () => {
    setShowNewRow(false);
    set_obj_editar(undefined);
    set_error_data(false);
    set_error_eficiencia_rega(false);
    set_error_volume(false);
    set_error_dotacao(false);
    set_error_teor(false);
    set_error_kg_n(false);
    sumatorio_das_quantidades(rowsAgua)
  }

  const onInputChange = (event: any) => {
    const { name, value } = event.target;
    set_flag_editado(true)
    if (name === "data_rega") {
      if (value === undefined || value === "") {
        set_error_data(true);
      } else {
        set_error_data(false);
      }
      set_obj_editar((prevAzoto: any) => ({
        ...prevAzoto,
        [name]: value,
      }));
    } else if (name === "eficiencia_rega") {

      if (/[a-zA-Z]/.test(value)) {
        set_error_eficiencia_rega(true);

      } else {
        set_error_eficiencia_rega(false);

        set_obj_editar((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === "volume") {

      if (/[a-zA-Z]/.test(value)) {
        set_error_volume(true);

      } else {
        set_error_volume(false);

        set_obj_editar((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === "dotacao") {

      if (/[a-zA-Z]/.test(value)) {
        set_error_dotacao(true);

      } else {
        set_error_dotacao(false);

        set_obj_editar((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === "teor") {

      if (/[a-zA-Z]/.test(value)) {
        set_error_teor(true);

      } else {
        set_error_teor(false);

        set_obj_editar((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === "kg_n") {

      if (/[a-zA-Z]/.test(value)) {
        set_error_kg_n(true);

      } else {
        set_error_kg_n(false);

        set_obj_editar((prevAzoto: any) => ({
          ...prevAzoto,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else {
      set_obj_editar((prevAzoto: any) => ({
        ...prevAzoto,
        [name]: value,
      }));
    }
  };

  const handleSaveAgua = async () => {

    if (
      obj_editar === undefined || obj_editar.data_rega === undefined || obj_editar.data_rega === ""
    ) {
      if (obj_editar?.data_rega === undefined || obj_editar?.data_rega === "") {
        set_error_data(true);
      }

      setMessage("Preencha os campos obrigatórios!");
      setOpenSnackError(true);
    } else {
      try {
        setIsLoading(true);
        let res = await post(auth.token.cookie_token, "new_reg_act_fertil_azotada_dois_5d", {
          payload: {
            id_registo_fertil_dois: 0,
            kg_n: obj_editar?.kg_n === undefined ? null : obj_editar.kg_n,
            teor: obj_editar?.teor === undefined ? null : obj_editar.teor,
            dotacao: obj_editar?.dotacao === undefined ? null : obj_editar.dotacao,
            volume: obj_editar?.volume === undefined ? null : obj_editar.volume,
            eficiencia_rega: obj_editar?.eficiencia_rega === undefined ? null : obj_editar.eficiencia_rega,
            metodo_rega: obj_editar?.metodo_rega === undefined ? null : obj_editar.metodo_rega,
            data_rega: obj_editar?.data_rega === undefined ? null : obj_editar.data_rega,
            id_act_feertil_azotada: cabecalho?.id_act_feertil_azotada,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: "",
          }
        });

        if (res.status === 200) {
          setMessage("Gravado com sucesso!");
          const resultArray = rowsAgua
          resultArray.push(res.data.result)
          setRowsAgua(resultArray);
          setRowsAgua_filtrada(resultArray);
          sumatorio_das_quantidades(resultArray)
          set_flag_editado(false)
          set_obj_editar(undefined);
          setOpenSnackSuccess(true);
          setShowNewRow(false);
          set_error_data(false);
          set_error_eficiencia_rega(false);
          set_error_volume(false);
          set_error_dotacao(false);
          set_error_teor(false);
          set_error_kg_n(false);
        } else {
          setMessage("Erro ao gravar!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      } catch (error:any) {
        func_print("handleSaveAgua", error, true);
        if (error?.status === 409) {

          setMessage(error?.response.data.detail);
          setOpenSnackError(true);
        } else {
          setMessage("Erro ao efetuar a sua operação!");
          setOpenSnackError(true);
        }
  
        setIsLoading(false);
      }
    }
  };





  const handleUpdateAgua = async () => {

    if (obj_editar?.data_rega === undefined || obj_editar?.data_rega === "") {
      set_error_data(true);
    } else {
      try {
        let res = await post(auth.token.cookie_token, "update_reg_act_fertil_azotada_dois_5d", {
          payload: {
            id_registo_fertil_dois: obj_editar.id_registo_fertil_dois,
            kg_n: obj_editar?.kg_n === undefined ? null : obj_editar.kg_n,
            teor: obj_editar?.teor === undefined ? null : obj_editar.teor,
            dotacao: obj_editar?.dotacao === undefined ? null : obj_editar.dotacao,
            volume: obj_editar?.volume === undefined ? null : obj_editar.volume,
            eficiencia_rega: obj_editar?.eficiencia_rega === undefined ? null : obj_editar.eficiencia_rega,
            metodo_rega: obj_editar?.metodo_rega === undefined ? null : obj_editar.metodo_rega,
            data_rega: obj_editar?.data_rega === undefined ? null : obj_editar.data_rega,
            id_act_feertil_azotada: obj_editar.id_act_feertil_azotada,
            last_update: new Date().toISOString(),
            create_date: obj_editar.create_date,
            uuid: obj_editar.uuid,
          }
        });

        if (res.status === 200) {
          setMessage("Registado com sucesso!");

          const updatedRows = rowsAgua.map((row) =>
            row.id_registo_fertil_dois === obj_editar.id_registo_fertil_dois ?
              res.data.result :
              row
          );
          setRowsAgua(updatedRows !== undefined ? updatedRows : []);
          setRowsAgua_filtrada(updatedRows !== undefined ? updatedRows : []);
          sumatorio_das_quantidades(updatedRows)
          set_obj_editar(undefined);
          setOpenSnackSuccess(true);
          set_error_data(false);
          set_error_eficiencia_rega(false);
          set_error_volume(false);
          set_error_dotacao(false);
          set_error_teor(false);
          set_error_kg_n(false);
          set_flag_editado(false)
        } else {
          setMessage("Erro ao gravar!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      } catch (error:any) {
        func_print("handleUpdateAgua", error, true);
        if (error?.status === 409) {

          setMessage(error?.response.data.detail);
          setOpenSnackError(true);
        } else {
          setMessage("Erro ao efetuar a sua operação!");
          setOpenSnackError(true);
        }
  
        setIsLoading(false);
      }
    }

  };

  // DELETE
  const handleClickOpenDeleteAgua = (obj: IAguaDeRega) => {
    set_obj_editar(obj);
    setOpenDeleteAgua(true);
  };

  const handleDeleteAgua = async () => {
    try {
      setIsLoading(true);
      let res = await del(auth.token.cookie_token, `/delete__reg_act_fertil_azotada_dois_5d/${obj_editar?.id_registo_fertil_dois}`);

      if (res.status === 200) {
        setMessage("Eliminado com sucesso!");
        let aux_array = rowsAgua.filter((row) => row.id_registo_fertil_dois !== obj_editar?.id_registo_fertil_dois);

        sumatorio_das_quantidades(aux_array)
        setRowsAgua(aux_array);
        setRowsAgua_filtrada(aux_array);
        set_obj_editar(undefined);
        setOpenDeleteAgua(false);
        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao eliminar!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handleDeleteAgua", error, true);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };


  /*****************  PAGINAÇÃO ********************** */
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rowsAgua_filtrada.length) : 0;

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };




  return (
    <CustomThemeProvider>
      {isLoading ?
        <LoadingVulpes /> :
        <TableContainer
          component={Paper}
          variant="outlined"
          sx={{ height: "auto", width: "auto", margin: 2, padding: 2, }}
        >
          <Snackbar
            open={openSnackSuccess}
            autoHideDuration={2000}
            onClose={() => setOpenSnackSuccess(false)}
          >
            <Alert
              onClose={() => setOpenSnackSuccess(false)}
              severity="success"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          <Snackbar
            open={openSnackError}
            autoHideDuration={2000}
            onClose={() => setOpenSnackError(false)}
          >
            <Alert
              onClose={() => setOpenSnackError(false)}
              severity="error"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          <table style={{ width: "100%" }}>
            <TableHead>
              <TableRow>
                <TableCell
                  colSpan={7}
                  sx={{ fontWeight: 600, textAlign: "left", fontFamily: "candara", fontSize: 16, }}
                >
                  2 - Azoto fornecido pela água de rega
                  <BasicPopover
                    text={"Quadro de preenchimento obrigatório apenas para as explorações em Zona Vulnerável para cumprimento do disposto na alínea a) do n.º 9 do artigo 8.º da Portaria n.º 259/2012, caso o beneficiário opte pelo registo em CCU."} />
                </TableCell>
                <TableCell colSpan={2}>
               { is_historico === true ? <></> :

                  <BarraDeFerramentas
                    mostrarBotaoNovo
                    textoBotaoNovo="Novo Registo"
                    aoClicarNovo={() => {
                      set_obj_editar(undefined)
                      setShowNewRow(true)
                    }}
                  />}
                </TableCell>
              </TableRow>
              <TableRow>
                <StyledTableHead>Data da rega (dd-mm-aaaa)*</StyledTableHead>
                <StyledTableHead>Método de rega</StyledTableHead>
                <StyledTableHead>Eficiência de rega (%)</StyledTableHead>
                <StyledTableHead>
                  Volume aplicado (m3/zona homogénea ou parcela)
                </StyledTableHead>
                <StyledTableHead>Dotação Total (m3/ha)</StyledTableHead>
                <StyledTableHead>
                  Teor em Nitratos
                  <Stack direction="row" justifyContent="center" alignItems="center">
                    (mg/l)
                    <BasicPopover
                      text={"A dedução de azoto só deverá ser efetuada a partir de 10 mg/l de nitratos, isto é, o N das águas de rega que apresentem teores iguais ou inferiores a 10 mg/l de NO3 não deve ser contabilizado"} />
                  </Stack>
                </StyledTableHead>
                <StyledTableHead>
                  kg de N / ha
                  <Stack direction="row" justifyContent="center" alignItems="center">
                    <BasicPopover
                      text={"Podem ser consideradas duas situações distintas, a seguir apresentadas:  \n\na) No caso da cultura do arroz e do agrião. \n\nN=0,000226xTx0,40xVxf \n\nN é a quantidade de azoto veiculada pela água, expressa em kg/ha; \nT - é o teor médio de nitratos da água de rega, em mg/l de NO3;\nV - é o volume total de água utilizada na rega, em m3/ha; \nF - é um fator que depende da eficiência da rega (a água retida no canteiro é cerca de 30 a 60% do volume de água fornecido). \nO fator 0,40 desta expressão corresponde à eficiência do azoto nítrico. \n\nb) Nos restantes casos. \n\nN=0,000226xTxVxF \n\nN é a quantidade de azoto veiculada pela água, expressa em kg/ha; \nT - é o teor médio de nitratos da água de rega, em mg/l de NO3;\nV - é o volume total de água utilizada na rega, em m3/ha; \nF - é um fator que depende da eficiência da rega (em rega localizada deve rondar 0,90 a 0,95).\n\nFonte: Manual das Boas Práticas para a Implementação do Programa de Ação em Zonas Vulneráveis de Portugal Continental (DGADR, 2021)."} />
                  </Stack>
                </StyledTableHead>
                <StyledTableHead>Ações</StyledTableHead>
              </TableRow>
            </TableHead>
            <TableBody>
              {showNewRow && (

                <TableRow>
                  <StyledTableCell>
                    <TextField
                      variant="filled"
                      type="date"
                      name="data_rega"
                      value={obj_editar?.data_rega === undefined ? "" : obj_editar.data_rega}
                      onChange={
                        onInputChange as (
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => void
                      }
                      error={error_data}
                      helperText={error_data ? "Preencha este campo" : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="metodo_rega"
                      value={obj_editar?.metodo_rega === undefined ? "" : obj_editar.metodo_rega}
                      onChange={onInputChange}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="eficiencia_rega"
                      value={obj_editar?.eficiencia_rega === undefined || obj_editar?.eficiencia_rega === null ? "" : obj_editar.eficiencia_rega.toString().replace('.', ',')}
                      onChange={onInputChange}
                      error={error_eficiencia_rega}
                      helperText={error_eficiencia_rega ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="volume"
                      value={obj_editar?.volume === undefined || obj_editar?.volume === null ? "" : obj_editar.volume.toString().replace('.', ',')}
                      onChange={onInputChange}
                      error={error_volume}
                      helperText={error_volume ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="dotacao"
                      value={obj_editar?.dotacao === undefined || obj_editar?.dotacao === null ? "" : obj_editar.dotacao.toString().replace('.', ',')}
                      onChange={onInputChange}
                      error={error_dotacao}
                      helperText={error_dotacao ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="teor"
                      value={obj_editar?.teor === undefined || obj_editar?.teor === null ? "" : obj_editar.teor.toString().replace('.', ',')}
                      onChange={onInputChange}
                      error={error_teor}
                      helperText={error_teor ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="kg_n"
                      value={obj_editar?.kg_n === undefined || obj_editar?.kg_n === null ? "" : obj_editar.kg_n.toString().replace('.', ',')}
                      onChange={onInputChange}
                      error={error_kg_n}
                      helperText={error_kg_n ? message_apenas_numero : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <Stack direction="row" justifyContent="center">
                      <ButtonCadernos
                        mostrarBotaoCancelar
                        aoClicarCancelar={() => {
                          if (flag_editado) {
                            set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                          } else {
                            handleCancel()
                          }
                        }}
                        mostrarBotaoGravar
                        aoClicarGravar={() => handleSaveAgua()}
                      />
                    </Stack>
                  </StyledTableCell>
                </TableRow>


              )}

              {(rowsPerPage > 0
                ? rowsAgua_filtrada.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : rowsAgua_filtrada
              ).map((row, key) => (
                <TableRow key={key}>
                  {obj_editar?.id_registo_fertil_dois === row.id_registo_fertil_dois ? (
                    <>
                      <StyledTableCell>
                        <TextField
                          variant="filled"
                          name="data_rega"
                          type="date"
                          value={obj_editar?.data_rega === undefined ? "" : obj_editar.data_rega}

                          onChange={
                            onInputChange as (
                              event: React.ChangeEvent<HTMLInputElement>
                            ) => void
                          }
                          error={error_data}
                          helperText={error_data ? "Preencha este campo" : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="metodo_rega"
                          value={obj_editar?.metodo_rega === undefined ? "" : obj_editar.metodo_rega}

                          onChange={onInputChange}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="eficiencia_rega"
                          value={obj_editar?.eficiencia_rega === undefined || obj_editar?.eficiencia_rega === null ? "" : obj_editar.eficiencia_rega.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_eficiencia_rega}
                          helperText={error_eficiencia_rega ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="volume"
                          value={obj_editar?.volume === undefined || obj_editar?.volume === null ? "" : obj_editar.volume.toString().replace('.', ',')}

                          onChange={onInputChange}
                          error={error_volume}
                          helperText={error_volume ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="dotacao"
                          value={obj_editar?.dotacao === undefined || obj_editar?.dotacao === null ? "" : obj_editar.dotacao.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_dotacao}
                          helperText={error_dotacao ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="teor"
                          value={obj_editar?.teor === undefined || obj_editar?.teor === null ? "" : obj_editar.teor.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_teor}
                          helperText={error_teor ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="kg_n"
                          value={obj_editar?.kg_n === undefined || obj_editar?.kg_n === null ? "" : obj_editar.kg_n.toString().replace('.', ',')}

                          onChange={onInputChange}
                          error={error_kg_n}
                          helperText={error_kg_n ? message_apenas_numero : ""}
                        />
                      </StyledTableCell>
                    </>
                  ) : (
                    <>
                      <StyledTableCell>{row.data_rega}</StyledTableCell>
                      <StyledTableCell>{row.metodo_rega}</StyledTableCell>
                      <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.eficiencia_rega)}</StyledTableCell>
                      <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.volume)}</StyledTableCell>
                      <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.dotacao)}</StyledTableCell>
                      <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.teor)}</StyledTableCell>
                      <StyledTableCell>{formatarNumero_recebido_com_casa_decimais(row.kg_n)}</StyledTableCell>
                    </>
                  )}

                  {obj_editar?.id_registo_fertil_dois === row.id_registo_fertil_dois ? (
                    <StyledTableCell>
                      <ButtonCadernos
                        mostrarBotaoGravar
                        aoClicarGravar={() => handleUpdateAgua()}
                        mostrarBotaoCancelar
                        aoClicarCancelar={() => {
                          if (flag_editado) {
                            set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                          } else {
                            handleCancel()
                          }
                        }}
                      />
                    </StyledTableCell>
                  ) : (
                    <StyledTableCell>
                  {  is_historico === true ? <></> :

                      <ButtonCadernos
                        mostrarBotaoEditar
                        aoClicarEditar={() => {
                          set_obj_editar(row);
                          set_total_dotacao(total_dotacao - row.dotacao)
                          set_total_kg_n(total_kg_n - row.kg_n)
                          set_total_teor(total_teor - row.teor)
                          set_total_volume(total_volume - row.volume)
                          set_error_data(false);
                          setShowNewRow(false);
                        }}
                        mostrarBotaoApagar
                        aoClicarApagar={() => handleClickOpenDeleteAgua(row)}
                      />}
                    </StyledTableCell>
                  )}
                </TableRow>
              ))}
              <TableRow>
                <TableCell colSpan={2}></TableCell>
                <StyledTableCell sx={{ textAlign: "center" }} >
                  {"Total:"}
                </StyledTableCell>
                <StyledTableCell>
                  {
                    obj_editar?.volume !== undefined ?
                      formatarNumero_recebido_com_casa_decimais(Number(total_volume) + Number(obj_editar?.volume)) :
                      formatarNumero_recebido_com_casa_decimais(total_volume)
                  }

                </StyledTableCell>
                <StyledTableCell>
                  {
                    obj_editar?.dotacao !== undefined ?
                      formatarNumero_recebido_com_casa_decimais(Number(total_dotacao) + Number(obj_editar?.dotacao)) :
                      formatarNumero_recebido_com_casa_decimais(total_dotacao)
                  }

                </StyledTableCell>
                <StyledTableCell>
                  {
                    obj_editar?.teor !== undefined ?
                      formatarNumero_recebido_com_casa_decimais(Number(total_teor) + Number(obj_editar?.teor)) :
                      formatarNumero_recebido_com_casa_decimais(total_teor)
                  }

                </StyledTableCell>
                <StyledTableCell>
                  {
                    obj_editar?.kg_n !== undefined ?
                      formatarNumero_recebido_com_casa_decimais(Number(total_kg_n) + Number(obj_editar?.kg_n)) :
                      formatarNumero_recebido_com_casa_decimais(total_kg_n)
                  }

                </StyledTableCell>
              </TableRow>
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={19} />
                </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow sx={{ width: "100%" }}>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: "Todos", value: -1 }]}
                  colSpan={14}
                  count={rowsAgua_filtrada.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  labelDisplayedRows={({ from, to, count }) => {
                    return `${from}–${to} de ${count !== -1 ? count : `mais do que ${to}`}`;
                  }}
                  labelRowsPerPage={'Linhas por página'}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </table>
        </TableContainer>
      }
      <ConfirmDialog
        open={openDeleteAgua}
        onClose={() => setOpenDeleteAgua(false)}
        onConfirm={handleDeleteAgua}
        message="Deseja eliminar o registo?"
      />
      <ConfirmDialog
        open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
        onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
        onConfirm={() => handleCloseDialog()}
        message={mensagem_tem_a_certeza_de_apagar_alteracoes}
      />
    </CustomThemeProvider>
  );
};
